module.exports = __webpack_public_path__ + "static/media/new_logo.df79f067.png";